import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/app/_utils/cn"

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  /* Diverges from stock shadcn: the thumb is absolutely positioned off the track's
     own box instead of riding a `translate-x-4` inside a transparent 2px border.
     Preflight is disabled app-wide (see app/globals.scss), so the track's border
     and the thumb's transform don't resolve to the sizes the stock classes assume
     and the thumb parked mid-track in both states. `left` off a `relative` track
     is self-contained: 2px inset when off, `calc(100% - 1.125rem)` (thumb + 2px
     inset) when on, so it sits flush left/right and still tracks a custom width. */
  <SwitchPrimitives.Root
    className={cn(
      "peer relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none absolute left-0.5 top-0.5 block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-[left] duration-200 data-[state=checked]:left-[calc(100%-1.125rem)]"
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
